import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { ODataParams } from '../_ODataTypes';
import { GetSlaResponseListResponse, SLAInitials } from './_clientTypes';
import { buildApiUrl } from '../../axios/urlCreator';
import { cachedGet } from '../../axios/responseCache';

const initialState: SLAInitials = {
    slas: null,
    loading: false,
    error: null
};

export const getSLAList = createAsyncThunk<GetSlaResponseListResponse, ODataParams | void>(
    'sla/getSLAList',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.filter) queryParams.append('$filter', params.filter);
            if (params?.orderby) queryParams.append('$orderby', params.orderby);
            if (params?.top != null) queryParams.append('$top', params.top.toString());
            if (params?.skip != null) queryParams.append('$skip', params.skip.toString());

            return await cachedGet<GetSlaResponseListResponse>(buildApiUrl("client/slas", queryParams), 300_000);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

const slaSlice = createSlice({
    name: 'sla',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSLAList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSLAList.fulfilled, (state, action) => {
                state.loading = false;
                state.slas = action.payload;
            })
            .addCase(getSLAList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export default slaSlice.reducer;
